import React from "react";
import { STATE_KEYS } from "utils/constants/state";
import { useFormikContext } from "formik";
import { useStripeFeature } from "utils/hooks/stripe";
import { STRIPE_FEATURES, STRIPE_ROUTES } from "utils/constants/stripe";
import { STRIPE_EDUCATION } from "constants/education";
import CheckoutTaxRatesPickers from "components/CheckoutTaxRatesPickers";
import StripeExternalLink from "components/StripeExternalLink";
import { getStripeDestination } from "utils/stripe";
import get from "lodash/get";
import { useMessagesError } from "utils/hooks/editor";
import classnames from "classnames";

const TaxRatePicker = () => {
  const { values } = useFormikContext();
  const autoTaxEnabled = get(
    values,
    STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX_ENABLED
  );
  const taxFeatureEnabled = useStripeFeature({ feature: STRIPE_FEATURES.TAX });
  const canEdit = !Boolean(values.id);
  const error = useMessagesError(STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX);

  const noRatesWhenAutoTaxes = taxFeatureEnabled && autoTaxEnabled;
  if (noRatesWhenAutoTaxes) {
    return null;
  }

  if (taxFeatureEnabled) {
    return (
      <div className="flex flex-column w-100 pv3 bt hairline-1">
        <label
          className={classnames("f5 fw6 db pb2", {
            "color-error": error
          })}
        >
          Tax rates
        </label>
        <div className="flex flex-row justify-between items-center pb3 bb hairline-1">
          <CheckoutTaxRatesPickers
            rootPath="data.product"
            name="checkout.tax_rates"
            editMode={canEdit}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="w-100 pb3">
      <div className="f6 lh-copy">
        {STRIPE_EDUCATION.AUTOMATIC_TAX.disabled}
      </div>
      <div className="pt2">
        <StripeExternalLink
          copy="Activate Stripe Tax"
          customClasses={{
            link:
              "link__decoration--hover color-primary pointer link flex flex-row items-center",
            copy: "f6 pr2 fw6 link__decoration--hover color-primary pointer"
          }}
          href={getStripeDestination({
            path: STRIPE_ROUTES.TAX_ACTIVATE,
            test: false
          })}
        />
      </div>
      <div className="flex flex-row justify-between items-center pv3 bb hairline-1 mb3">
        <CheckoutTaxRatesPickers
          rootPath="data.product"
          name="checkout.tax_rates"
          editMode={canEdit}
        />
      </div>
    </div>
  );
};

export default TaxRatePicker;
